import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {
    FormArrayInputModule
} from '../../../../../../../../components/common/form-array/form-array-input/form-array-input.module';
import {IonicModule} from '@ionic/angular';
import {FormFieldModule} from '../../../../../../../core/component/form-field/form-field.module';
import {InputTextModule} from '../../../../../../../core/component/input-text/input-text.module';
import {
    FormDefinitionFieldSearchByLabelModule
} from '../../../../api/component/form-definition-field-search-by-label/form-definition-field-search-by-label.module';
import {
    ReportComponentLabelDefaultValueValueRowsJsonHandlerComponent
} from './report-component-label-default-value-value-rows-json-handler.component';
@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormArrayInputModule,
        IonicModule,
        FormFieldModule,
        InputTextModule,
        FormDefinitionFieldSearchByLabelModule,
    ],
    declarations: [
        ReportComponentLabelDefaultValueValueRowsJsonHandlerComponent,
    ],
    exports: [
        ReportComponentLabelDefaultValueValueRowsJsonHandlerComponent
    ],
})
export class ReportComponentLabelDefaultValueValueRowsJsonHandlerModule {
}
